const ImageBlender = require('ImageBlender');

cc.Class({
    extends: cc.Component,

    properties: {
        blender: ImageBlender,
        overlay: cc.Node,
        shield: sp.Skeleton,
        day: {
            default: true,
            notify: function() {
                this._sync();
            }
        }
    },

    _sync () {
        if (this.day) {
            this.blender.blend = 1;
            this.overlay.opacity = 127;
            this.shield.setSkin('osnova');
            this.shield.setMix(this.shield.animation, this.shield.animation, 0.2);
            this.shield.setAnimation(0, this.shield.animation, true);
        } else {
            this.blender.blend = 0;
            this.overlay.opacity = 255;
            this.shield.setSkin('freespins');
            this.shield.setMix(this.shield.animation, this.shield.animation, 0.2);
            this.shield.setAnimation(0, this.shield.animation, true);
        }
    },

    playNight (time = 0.5) {
        cc.tween(this.blender).to(time, { blend: 0 }).call(() => {
            this.day = false;
        }).start();

        cc.tween(this.overlay).to(time, { opacity: 255 }).start();
    },

    playDay (time = 0.5) {
        cc.tween(this.blender).to(time, { blend: 1 }).call(() => {
            this.day = true;
        }).start();

        cc.tween(this.overlay).to(time, { opacity: 127 }).start();
    },


});
